module.exports = __webpack_public_path__ + "img/Angiogenesis-OVCA_10X_WTA.1a473952.png";